import { render, staticRenderFns } from "./Tooth.vue?vue&type=template&id=3056f564&scoped=true"
import script from "./Tooth.vue?vue&type=script&lang=js"
export * from "./Tooth.vue?vue&type=script&lang=js"
import style0 from "./Tooth.vue?vue&type=style&index=0&id=3056f564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056f564",
  null
  
)

export default component.exports